import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import {
  ExportTemplatePayload,
  Template
} from '@utils/types/organization/export-template.ts';

interface UpdateTemplatePayload {
  id: number;
  data: ExportTemplatePayload;
}

const putExportTemplate = ({ id, data }: UpdateTemplatePayload) => {
  const formData = new FormData();
  formData.append('name', data.name);

  if (data.template_type) {
    formData.append('template_type', data.template_type);
  }

  if (data.template_docx) {
    formData.append('docx_template', data.template_docx);
  }

  if (data.template_example) {
    formData.append('example_template', data.template_example);
  }

  // Add prompt if it exists, empty string will set it to null
  if (data.prompt !== undefined && data.prompt !== null) {
    formData.append('prompt', data.prompt);
  }

  return Axios.put<Template>(PUT_URL(id.toString()).exportTemplates, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(res => res.data);
};

export const useUpdateExportTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation<Template, AxiosError<BaseError>, UpdateTemplatePayload>(
    putExportTemplate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.exportTemplates());
      },
      useErrorBoundary: false
    }
  );
};
